<div class="form-check" *ngFor="let item of efnZones">
  <label class="form-check-label">
    <input checkboxArray [ngValue]="item.key" [formControl]="control" type="checkbox" class="form-check-input">
    {{item.lookupValue}}
  </label>
</div>
